
<template>
  <!--footer start-->
    <footer class="footer widget-footer clearfix">
        <div class="first-footer ttm-bgcolor-skincolor">
            <div class="container">
                <div class="row">
                    <div class="widget-area col-xs-12 col-sm-12 col-md-6 col-lg-4">
                        <aside class="widget widget-text">
                            <!--featured-icon-box-->
                            <div class="featured-icon-box iconalign-before-heading">
                                <div class="featured-icon">
                                    <div class="ttm-icon ttm-icon_element-border ttm-icon_element-color-white ttm-icon_element-size-sm ttm-icon_element-style-square">
                                        <i class="fa fa-phone"></i>
                                    </div>
                                </div>
                                <div class="featured-title">
                                    <h5>+234 906 282 2257</h5>
                                    <h4>Have a question? call us now</h4>
                                </div>
                            </div><!-- featured-icon-box end-->
                        </aside>
                    </div>
                    <div class="widget-area col-xs-12 col-sm-12 col-md-6 col-lg-4">
                        <aside class="widget widget-text">
                            <!--featured-icon-box-->
                            <div class="featured-icon-box iconalign-before-heading">
                                <div class="featured-icon">
                                    <div class="ttm-icon ttm-icon_element-border ttm-icon_element-color-white ttm-icon_element-size-sm ttm-icon_element-style-square">
                                        <i class="fa fa-envelope-o"></i>
                                    </div>
                                </div>
                                <div class="featured-title">
                                    <h5>info@agropark.ng</h5>
                                    <h4>Need support? Drop us an email</h4>
                                </div>
                            </div><!-- featured-icon-box end-->
                        </aside>
                    </div>
                    <div class="widget-area col-xs-12 col-sm-12 col-md-6 col-lg-4">
                        <aside class="widget widget-text">
                            <!--featured-icon-box-->
                            <div class="featured-icon-box iconalign-before-heading">
                                <div class="featured-icon">
                                    <div class="ttm-icon ttm-icon_element-border ttm-icon_element-color-white ttm-icon_element-size-sm ttm-icon_element-style-square">
                                        <i class="fa fa-clock-o"></i>
                                    </div>
                                </div>
                                <div class="featured-title">
                                    <h5>Mon – Fri 08:00am – 5:00pm</h5>
                                    <h4>We are open</h4>
                                </div>
                            </div><!-- featured-icon-box end-->
                        </aside>
                    </div>
                </div>
            </div>
        </div>
         <div class="second-footer ttm-textcolor-white">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 widget-area">
                        <div class="widget widget_text clearfix">
                            <h3 class="widget-title">About Agropark</h3>
                            <div class="textwidget widget-text">
                                Agro-Park is primarily a farm management company involved in the end to end of agricultural value chain
                                <br><br>
                                <div class="social-icons social-hover">
                                    <ul class="list-inline">
                                        <li class="social-facebook"><a class="tooltip-top" target="_blank" href="https://web.facebook.com/agroparkng?_rdc=1&_rdr" data-tooltip="Facebook"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
                                        <li class="social-twitter"><a class="tooltip-top" target="_blank" href="https://twitter.com/agroparkng" data-tooltip="Twitter"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
                                        <li class="social-instagram"><a class=" tooltip-top" target="_blank" href="https://www.instagram.com/agroparkng/" data-tooltip="Instagram"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 widget-area">
                        <div class="widget widget_nav_menu clearfix">
                           <h3 class="widget-title">Quick Links</h3>
                            <ul id="menu-footer-quick-links">
                                <li><router-link to="/about" tag="a"> About Us</router-link></li>
                                <li><router-link to="/contact" tag="a"> Contact Us </router-link></li>
                                <li><router-link tag="a" to="/asset-management"> Farm Management </router-link></li>
                                <li><router-link tag="a" to="/agribusiness-academy">Agribusiness Academy </router-link></li>
                                <li><router-link to="/gallery" tag="a"> Gallery </router-link></li>
                            </ul>
                        </div>
                    </div>

                     <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 widget-area">
                        <div class="widget widget_nav_menu clearfix">
                           <h3 class="widget-title">Featured Links</h3>
                            <ul id="menu-footer-quick-links">
                                <li><a href="https://www.app.agropark.ng/#/">Portal</a></li>
                                <li><a href="https://blog.agropark.ng/">Blog</a> </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 widget-area">
                        <div class="widget widget_nav_menu menu-footer-services-menu clearfix">
                            <h3 class="widget-title">About Us</h3>
                            <ul id="menu-footer-services-menu" class="menu">
                                <li><router-link to="/our-team" tag="a"> Our Team</router-link></li>
                                <li><router-link to="/partners" tag="a"> Partners</router-link></li>
                                <li><router-link to="/gallery" tag="a"> Gallery</router-link></li>
                                <li><router-link to="/bulletin" tag="a"> Bulletin </router-link></li>
                                <li><router-link to="/brochure" tag="a"> Brochure</router-link></li>
                                <li><router-link to="/faq" tag="a"> FAQ</router-link></li>
                                <li><router-link to="/graduate-trainee" tag="a"> Careers</router-link></li>
                            </ul>
                        </div>
                        <div class="widget widget-text clearfix">
                           <h3 class="widget-title">Newsletter</h3>
                            <form id="subscribe-form" method="post" action="#" data-mailchimp="true">
                                <div class="ttm_subscribe_form">
                                    <input type="email" name="EMAIL" placeholder="Enter Your Email" required="">
                                    <button class="btn" type="submit"> <i class="fa fa-envelope-o"></i> </button>
                                </div>
                                <div class="subscribe-response"></div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom-footer-text ttm-textcolor-white">
            <div class="container">
                <div class="row copyright">
                    <div class="col-md-12">
                        <span>Copyright © 2020 <router-link to="/" tag="a"> AgroPark Dev. Company Ltd </router-link> </span>
                    </div>
                    <div class="col-md-12">
                        <!-- <ul id="menu-footer-menu" class="footer-nav-menu">
                            <li><a href="#">About Us</a></li>
                            <li><a href="#">Services</a></li>
                            <li><a href="#">Privacy</a></li>
                        </ul> -->
                    </div>
                </div>
            </div>
        </div>
    </footer>
    <!--footer end-->
</template>

<script>
export default {
  name: "Footer",
  props: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



